module.exports = __webpack_public_path__ + "static/img/about.eef50aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/about.jpg
// module id = mbnw
// module chunks = 2